export default {
  setEmployeeProjects(state, projects) {
    state.employeeProjects = projects;
  },
  setTasksByProject(state, tasks) {
    state.tasksByProject = tasks;
  },
  setTask(state, task) {
    state.task = task;
  },
  tableLoading(state, value) {
    state.tableLoading = value;
  },
  currentPage(state, value) {
    state.currentPage = value;
  },
  perPage(state, value) {
    state.perPage = value;
  },
  searchQuery(state, value) {
    state.searchQuery = value;
  },
  paginationTotal(state, value) {
    return (state.total = value);
  },
  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
  },
};
